import { api } from '@/utils';

export default {
  name: 'ActivityAssigner',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    title: 'Activity',
    selectedActivity: null,
    formFields: {
      activity: {
        name: 'activity',
      },
    },
    activities: [],
    apiVersion: 1,
    pageSize: 100,
  }),
  computed: {
    disableSelect() {
      const isDossier = this.inputFormType === 'Dossier';
      if (isDossier) {
        this.selectedActivity = null;
      }

      return isDossier;
    },
  },
  methods: {
    searchActivities(dossierId) {
      // BASEURL
      let url = '/activities?';

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      // DossierId
      url += `&dossier=${dossierId}`;

      api.get(url)
        .then((response) => {
          this.activities = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dossierChanged(dossierId) {
      if (dossierId != null) {
        this.searchActivities(dossierId);
      } else {
        this.activities = [];
      }
    },
    onInputFormSaved() {
      if (this.selectedActivity != null) {
        this.$eventHub.$emit('fetch-activity-id', this.selectedActivity);
      }
    },
    onRelinkInputForm() {
      if (this.selectedActivity != null) {
        this.$eventHub.$emit('fetch-activity-id', this.selectedActivity);
      }
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm.link != null) {
        this.selectedActivity = this.inputForm.link.activityId;
      }
    },
  },
  created() {
    this.$eventHub.$on('dossier-selected-in-dossier-assigner', this.dossierChanged);
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
    this.$eventHub.$on('on-relink-input-form', this.onRelinkInputForm);
  },
};
